export default __webpack_public_path__ + "static/bjamin-9328664ee48ac12501947233eea6b133.jpg";